import { DriverSettlement } from "../DriverSettlement";
import { DataSource, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutDriverSettlementMultiProfile extends Layout {
    layoutOrderPayables: DriverSettlement;
    sourceDriverSettlementProfile: DataSource;
    sourceOrderPayablesCache: DataSource;
    sourcePayeeCache: DataSource;
    sourceStateFederalTaxDriverSettlement: DataSource;
    sourceVoidedPayablesDriverSettlement: DataSource;
    tabProfile: Tab;
    tabsetDriverSettlementProfiles: Tabset;
}
